import { AlphaRBoxOutlineIcon } from './AlphaRBoxOutlineIcon';

/**
 * author: Contributors
 * id 206DB27B-1F78-481F-8E8E-1A78F8221EF7
 * name alpha-r-box-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-r-box-outline.svg
 * tags
 * - Alpha / Numeric 
 */
export const LetterRBoxOutlineIcon = AlphaRBoxOutlineIcon;
export default LetterRBoxOutlineIcon